import { useTranslation } from 'react-i18next'

import { PaymentInfo } from '@widgets/payment-info'

import SEO from '@shared/components/SEO'
import { BRAND_NAME } from '@shared/contants/app'

export default function PaymentPage () {
  const { t } = useTranslation('seo')
  return (
    <>
      <SEO
        title={t('payment.title', { brand: BRAND_NAME })}
        description={t('payment.description', { brand: BRAND_NAME })}
      />
      <PaymentInfo />
    </>
  )
}
